// Swiper utility functions to prevent loop mode errors
window.SwiperUtils = {
  // Check if loop mode should be enabled based on slide count and slides per view
  shouldEnableLoop: function(slideCount, slidesPerView = 1) {
    // Loop requires at least 2 slides, and more slides than slides per view
    return slideCount > 1 && slideCount > slidesPerView;
  },
  
  // Get safe swiper configuration that prevents loop warnings
  getSafeConfig: function(slideCount, config = {}) {
    const slidesPerView = config.slidesPerView || 1;
    const shouldLoop = this.shouldEnableLoop(slideCount, slidesPerView);
    
    return {
      ...config,
      loop: shouldLoop,
      // Disable autoplay if loop is disabled and only 1 slide
      autoplay: shouldLoop && config.autoplay ? config.autoplay : false
    };
  }
};

// Global fix for external scripts (like Rebuy) that might create Swipers with loop warnings
document.addEventListener('DOMContentLoaded', function() {
  // Override console.warn to filter out Swiper loop warnings
  const originalWarn = console.warn;
  console.warn = function(...args) {
    const message = args.join(' ');
    // Skip Swiper loop warnings but allow other warnings
    if (message.includes('Swiper Loop Warning') || message.includes('number of slides is not enough for loop mode')) {
      return;
    }
    originalWarn.apply(console, args);
  };
});